import React from "react";

export default function NamePicker() {
  const [activeTab, setActiveTab] = React.useState("0");

  return <>NamePicker works!</>;
}
